module.exports = __webpack_public_path__ + "static/large-product-finder@2x-77eb43c8e129526531f9deb03a3182dd.png";